import React, { Component } from "react";
import { ReactComponent as FolderSvg } from "../../images/folder-regular.svg";
import { Link } from "react-router-dom";
import OptionsDropdown from "./OptionsDropdown";
import Axios from "axios";
import { Alert } from "react-bootstrap";

export default class FoldersTable extends Component {
    state = {
        error: null,
        alert: null,
    };

    getDropdownOptions(siblingFolders, parentfolder) {
        return (selectedFolderId) => {
            return siblingFolders
                .filter(folder => folder.id !== selectedFolderId)
                .map(folder => ({
                    name: folder.name,
                    id: folder.id,
                }))
                .concat(parentfolder ? [{ name: `../${parentfolder.name}`, id: parentfolder.id }] : []);
        }
    }

    moveFolderAPI(folderId) {
        return (folderToId) => {
            Axios.patch(process.env.REACT_APP_BACKEND_URL + "/folder/" + folderId, {
                parent: folderToId,
            }).then(() => {
                this.setState({
                    alert: {
                        title: "Folder Moved!",
                        body: "The folder has been successfully moved."
                    }
                });
                if (typeof this.props.refetchData === 'function') {
                    this.props.refetchData();
                }
            }).catch(({ response }) => {
                const errorMsg = response?.data?.message || '';
                this.setState({
                    error: {
                        title: "Error Moving Folder!",
                        body: "Server reported an error: " + errorMsg,
                    }
                });
            });
        }
    }

    deleteFolderAPI(folderId) {
        return () => {
            Axios.delete(process.env.REACT_APP_BACKEND_URL + "/folder/" + folderId).then(() => {
                this.setState({
                    alert: {
                        title: "Folder Deleted!",
                        body: "The folder has been successfully removed."
                    }
                });
                if (typeof this.props.refetchData === 'function') {
                    this.props.refetchData();
                }
            }).catch(err => {
                this.setState({
                    error: {
                        title: "Folder unable to be deleted!",
                        body: "Server reported an error: " + err.response?.data?.message,
                    }
                });
            });
        }
    }

    render() {
        const { folders, parentFolder } = this.props;
        const { error, alert } = this.state;
        const dropdownOptions = this.getDropdownOptions(folders, parentFolder);

        return <>
            <table className={"full-table mt-5"} cellPadding={16}>
                <tbody>
                    <tr>
                        <th>
                            Name
                        </th>
                        <th>
                            # Campaigns
                        </th>
                    </tr>
                    {folders?.length ?
                        <>
                            {folders.map(folder => {
                                return <tr key={folder.id}>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <FolderSvg />
                                            <Link to={`/campaigns/folder/${folder.id}`} className="boring-btn ms-2">
                                                {folder.name}
                                            </Link>
                                        </div>
                                    </td>
                                    <td>
                                        {folder.campaignsCount}
                                    </td>
                                    <td className="d-flex justify-content-end pe-5">
                                        <OptionsDropdown
                                            options={dropdownOptions(folder.id)}
                                            onItemClick={this.moveFolderAPI(folder.id)}
                                            onDelete={this.deleteFolderAPI(folder.id)}
                                        />
                                    </td>
                                </tr>
                            })}
                        </> : <></>
                    }
                </tbody>
            </table>
            {error?.title && (
                <Alert className="mx-auto alert-top-right w-50" variant="danger"
                    onClose={() => this.setState({ error: null })} dismissible>
                    <Alert.Heading>{error?.title}</Alert.Heading>
                    <p>{error?.body}</p>
                </Alert>
            )}
            {alert?.title && (
                <Alert className="mx-auto alert-top-right w-50" variant="success"
                    onClose={() => this.setState({ alert: null })} dismissible>
                    <Alert.Heading>{alert?.title}</Alert.Heading>
                    <p>{alert?.body}</p>
                </Alert>
            )}
        </>
    }
}